import { Box, makeStyles } from "@material-ui/core";
import React from "react";
import DaikukoContainer from "../../component/DaikukoContainer";
import Footer from "../../component/Footer";
import NavigationBar from "../../component/NavigationBar";
import ItemBackground from "../items/ItemBackground";
import NewsMobile from "./mobile/NewsMobile";
import NewsContent from "./NewsContent";
import NewsInfoBox from "./NewsInfoBox";

const useStyles = makeStyles((theme) => ({
  newsContainer: {
    height: "auto",
    position: "relative",

    minHeight: "100vh",
  },
  paddingBox: {
    [theme.breakpoints.between("sm", "sm")]: {
      width: "100%",
      padding: "0 15px",
    },
    [theme.breakpoints.down("s")]: {
      width: "100%",
      padding: "0 20px",
    },
  },
}));
export default function News() {
  const classes = useStyles();
  return (
    <Box className={classes.newsContainer}>
      <NavigationBar />
      <ItemBackground />
      <DaikukoContainer title="大国通信">
        <Box className={classes.paddingBox}>
          <NewsInfoBox />
        </Box>
        <NewsContent />
        <NewsMobile />
      </DaikukoContainer>{" "}
      <Footer />
    </Box>
  );
}
